import React from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { subscriptionsColumn } from './columns';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { Box, Button, Modal, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { API_BASE_ATHENEUM } from '../../../environments';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const Query = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [subscriptions, setSubscriptions] = React.useState([]);
  const [courseName, setCourseName] = React.useState('');
  const [courseSeoUrl, setCourseSeoUrl] = React.useState('');
  const [offerToApply, setOfferToApply] = React.useState(null);
  const [offerValidity, setOfferValidity] = React.useState(null);
  const [selectedProgram, setSelectedProgram] = React.useState(null);
  // const [courses, setCourses] = React.useState([]);
  const [programs, setPrograms] = React.useState([]);

  React.useEffect(() => {
    fetchAllPrograms();
    fetchAllCourses();
  }, []);

  const fetchAllCourses = async () => {
    fetch(`${API_BASE_ATHENEUM}courses`)
      .then((response) => response.json())
      .then((courseResponse) => {
        // setCourses(courseResponse);
      })
      .catch((err) =>
        toast.error('Courses could not be fetched, you could reload the page!')
      );
  };

  const fetchAllPrograms = async () => {
    fetch(`${API_BASE_ATHENEUM}programs`)
      .then((response) => response.json())
      .then((programResponse) => {
        setPrograms(programResponse);
      })
      .catch((err) =>
        toast.error('Programs could not be fetched, you could reload the page!')
      );
  };

  const addCourse = async () => {
    if (!_.isEmpty(courseName) && !_.isEmpty(courseSeoUrl)) {
      let headersList = {
        Accept: '*/*',
        'Content-Type': 'application/json',
      };
      const payload = JSON.stringify({
        name: courseName,
        course_name: courseName,
        course_seo_url: courseSeoUrl,
        program_id: selectedProgram._id,
        offer: offerToApply,
        offer_validity: offerValidity,
      });

      fetch(`${API_BASE_ATHENEUM}courses`, {
        body: payload,
        headers: headersList,
        method: 'POST',
      })
        .then((response) => response.json())
        .then((courseResponse) => {
          fetchAllPrograms();
          fetchAllCourses();
          toast.success('Course added successfully!');
        })
        .catch((err) => {
          console.log(err);
          toast.error('Programs could not be added, please try again!');
        });
    } else {
      toast.warning('Program name and seo url is mandatory!');
    }
  };

  React.useEffect(() => {
    fetchAllSubscriptions();
  }, []);

  const fetchAllSubscriptions = async () => {
    fetch('http://localhost:3008/ath-subsriptions')
      .then((response) => response.json())
      .then((subscriptionsResponse) => {
        setSubscriptions(subscriptionsResponse);
      })
      .catch((err) =>
        toast.error(
          'Subscriptions could not be fetched, you could reload the page!'
        )
      );
  };

  return (
    <Box>
      <Button onClick={handleOpen} variant="contained" color="primary">
        Subscribe Now
      </Button>
      <Box my={4}>
        <BuzzTable columns={subscriptionsColumn} data={subscriptions} />
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Box>
            <Typography>Add to Subscription</Typography>
            <Box alignItems="center">
              <Box my={2}>
                <TextField
                  required
                  id="outlined-basic"
                  label="Course Name"
                  variant="outlined"
                  value={courseName}
                  onChange={(e) => setCourseName(e.target.value)}
                  size="small"
                  fullWidth
                />
              </Box>
              <Box mx={2} />
              <Box>
                <Autocomplete
                  disablePortal
                  fullWidth
                  onChange={(e, value) => setSelectedProgram(value)}
                  id="combo-box-demo"
                  options={programs}
                  getOptionLabel={(option) => String(option.program_name)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Head Program"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              </Box>
              <Box mx={2} />
            </Box>

            <Box alignItems="center">
              <Box my={2}>
                <TextField
                  required
                  id="outlined-basic"
                  label="Course SEO url"
                  variant="outlined"
                  value={courseSeoUrl}
                  size="small"
                  fullWidth
                  onChange={(e) => setCourseSeoUrl(e.target.value)}
                />
              </Box>
            </Box>
            <Box my={1} display="flex" alignItems="center">
              <TextField
                required
                id="outlined-basic"
                label="Offer to apply"
                variant="outlined"
                size="small"
                fullWidth
                value={offerToApply}
                onChange={(e) => setOfferToApply(e.target.value)}
              />
              <Box mx={1} />
              <input
                type="datetime-local"
                id="offerValidityTime"
                name="offerValidityTime"
                onChange={(e) => setOfferValidity(e.target.value)}
                value={offerValidity}
              />
            </Box>
            <Box my={2}>
              <Button variant="contained" color="primary" onClick={addCourse}>
                Subscription
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Query;
